module.exports = __webpack_public_path__ + "static/media/tutorial.c70ab27e.mp4";